// PRODUCTIE OF DEVELOPMENT??? YOU MUST CHOOSE, BUT CHOOSE WISELY....  
// https://www.youtube.com/watch?v=oF2UrYSDb3k



//  ______               _                                  _              _   _   _                 
//  |  _  \             | |                                | |            | | | | (_)                
//  | | | |_____   _____| | ___  _ __  _ __ ___   ___ _ __ | |_   ___  ___| |_| |_ _ _ __   __ _ ___ 
//  | | | / _ \ \ / / _ \ |/ _ \| '_ \| '_ ` _ \ / _ \ '_ \| __| / __|/ _ \ __| __| | '_ \ / _` / __|
//  | |/ /  __/\ V /  __/ | (_) | |_) | | | | | |  __/ | | | |_  \__ \  __/ |_| |_| | | | | (_| \__ \
//  |___/ \___| \_/ \___|_|\___/| .__/|_| |_| |_|\___|_| |_|\__| |___/\___|\__|\__|_|_| |_|\__, |___/
//                              | |                                                         __/ |    
//                              |_|                                                        |___/     

//export const CONFIG_BASE_CLIENT_URL = "https://localhost:6001";                     // De url waar deze client op draait waar deze client op draait
//export const CONFIG_BASE_API_URL = "https://localhost:5003";                        // De url van de trainings api
//export const CONFIG_BASE_IDENTITY_URL = "https://localhost:5001";                   // De url van de identity server
//export const CONFIG_CLIENT_NAME = "oidcClient";
//export const CONFIG_CLIENT_SECRET = "SuperSecretPassword";


//  ______              _            _   _                        _   _   _
//  | ___ \            | |          | | (_)                      | | | | (_)                
//  | |_/ / __ ___   __| |_   _  ___| |_ _  ___  _ __    ___  ___| |_| |_ _ _ __   __ _ ___ 
//  |  __/ '__/ _ \ / _` | | | |/ __| __| |/ _ \| '_ \  / __|/ _ \ __| __| | '_ \ / _` / __|
//  | |  | | | (_) | (_| | |_| | (__| |_| | (_) | | | | \__ \  __/ |_| |_| | | | | (_| \__ \
//  \_|  |_|  \___/ \__,_|\__,_|\___|\__|_|\___/|_| |_| |___/\___|\__|\__|_|_| |_|\__, |___/
//                                                                                 __/ |    
//                                                                                |___/     
 
export const CONFIG_BASE_CLIENT_URL = "https://training.logisticworkx-portal.nl";     // De url waar deze client op draait
export const CONFIG_BASE_API_URL = "https://trainingapi.logisticworkx-portal.nl";        // De url van de trainings api
export const CONFIG_BASE_IDENTITY_URL = "https://identity.logisticworkx-portal.nl";   // De url van de identity server
export const CONFIG_CLIENT_NAME = "oidcClient";
export const CONFIG_CLIENT_SECRET = "SuperSecretPassword";